import { _PopoverContent } from "./content";
import { _Popover } from "./popover";
import { _PopoverToggle } from "./toggle";

export const Popover = Object.assign(_Popover, {
  Toggle: _PopoverToggle,
  Content: _PopoverContent,
});
